import './Product.css'
import { Box, useMediaQuery } from "@mui/material"
import CustomCarousel from "components/blocks/customCarousel/CustomCarousel"
import ProductsScrollBlock from "components/blocks/productsScrollBlock/ProductsScrollBlock"
import Headline2 from 'components/elements/Headline2'
import Headline3 from 'components/elements/Headline3'
import Headline6 from 'components/elements/Headline6'
import Image from "components/elements/Image"
import ProductBreadcrumb from 'components/elements/ProductBreadcrumb'
import ArrowLeft from "components/icons/ArrowLeft"
import ArrowRight from "components/icons/ArrowRight"
import SectionWrapper from "components/layouts/SectionWrapper"
import { AppContext } from "contexts/AppContext"
import { useContext } from "react"
import { useNavigate } from 'react-router-dom'
import Activity from "utils/Activity"
import { callAPI } from "utils/API"
import { getTranslatedProductTitle } from 'utils/general'
import { translate } from "utils/Translate"

const ProductContainer = (props) => {
    const { activeIndex, interval, productDetails, ShopID, children } = props

    const { styleGuide, langCode } = useContext(AppContext)
    const isMobile = useMediaQuery('(max-width: 900px)');
    const navigate = useNavigate()

    const productTitle = getTranslatedProductTitle(productDetails, langCode)

    return (
        <div style={{ display: 'flex', flexDirection: 'column', zIndex: 0, marginTop: 40 }}>
            <SectionWrapper>
                <div style={{position: 'relative', width: '100%'}}>
                    <div className='product-container' id='product-container'>
                        <div className='product-image-container'>
                            <CustomCarousel
                                id={`product-images ${interval}`}
                                activeIndex={activeIndex}
                                style={{ position: 'sticky', top: 0 }}
                                interval={interval}
                                indicators={true}
                                nextIcon={<ArrowRight fill={styleGuide.color1} />}
                                prevIcon={<ArrowLeft fill={styleGuide.color1} />}
                                children={
                                    productDetails.images.sort((a,b) => a.poolOrder - b.poolOrder).map(image => <Image
                                        className='product-details-image'
                                        style={{backgroundColor: image.backgroundColor || styleGuide.productImageBackgroundColor }}
                                        key={image.ImageID}
                                        src={`url(${image.imageOriginSource})`} />
                                    )
                                }
                            />
                        </div>
                        <div className='product-details-container'>
                            <div className='product-details-section'>
                                <ProductBreadcrumb productDetails={productDetails} ShopID={ShopID} productTitle={productTitle} />
                                {isMobile
                                    ?
                                    <Headline3 style={{ marginTop: 24, color: styleGuide.color7 }}>{productTitle}</Headline3>
                                    :
                                    <Headline2 style={{ marginTop: 48, color: styleGuide.color7 }}>{productTitle}</Headline2>
                                }
                                <Headline6 className="hoverUnderline" style={{ marginTop: 10, color: styleGuide.color6, cursor: 'pointer' }} onClick={() => navigate(`/shop/${ShopID}?brand=${encodeURIComponent(productDetails.manufacturer)}`, { state: { scrollToTop: true } })}>
                                    {productDetails.manufacturer || <></>}
                                </Headline6>

                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </SectionWrapper>
            <SectionWrapper backgroundColor={styleGuide.color3} sx={{marginTop: '40px', marginBottom: '-100px'}}>
                <Box paddingTop={6} paddingBottom={8}>
                    <ProductsScrollBlock
                        caption={translate("_FEATURED_PRODUCTS_CAPTION_", 'Fremhævede produkter')}
                        fetchProducts={async () => await callAPI(`/product/popularProducts`, "GET")}
                        onSeeMoreClicked={() => Activity({ activityType: 'click', activityName: 'product', activityArgument: 'Shop', activityArgumentID: ShopID })}
                    />
                </Box>
            </SectionWrapper>
        </div>
    )
}

export default ProductContainer